<template>
  <div>
    <div class="text-xs-right">
      <v-btn icon small @click="$emit('close')">
        <v-icon small>close</v-icon>
      </v-btn>
    </div>
    <h1 class="pl-5 mt-0 mb-3">ข้อมูลการใช้ส่วนลด</h1>
    <div v-if="loading" class="text-xs-center pa-5">
      <v-progress-circular indeterminate class="mx-auto"></v-progress-circular>
    </div>
    <div v-else class="px-5 pb-3">
      <div v-if="data.length">
        <v-card v-for="item in data" :key="item.id" class="mb-3">
          <v-layout>
            <v-flex xs3 class="text-xs-center py-2" style="border-right: 1px solid #eee">
              <div style="font-size: 11px; color: grey">Discount</div>
              <div style="font-weight: 500; font-size: 34px; line-height: 38px">10%</div>
            </v-flex>
            <v-flex xs9 class="pa-2">
              <div style="font-weight: 500">{{ item.brand }} - {{ item.branch }}</div>
              <div>{{ item.remark }}</div>
              <div class="text-xs-right" style="font-size: small">
                {{ item.timestamp | DateFormat('DD/MM/YYYY') }}
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </div>
      <div v-else class="pt-3">
        <v-card class="pa-4">
          <div style="color: grey" class="text-xs-center">ไม่มีข้อมูลการใช้ส่วนลด</div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  props: ['userid', 'card_id'],
  computed: {
    ...mapGetters(['selectedBot'])
  },
  data() {
    return {
      loading: false,
      data: []
    }
  },
  async mounted() {
    this.loading = true
    this.data = await this.postgpkdiscountusagehistorydashboard()
    console.log(this.data)
    this.loading = false
  },
  methods: {
    postgpkdiscountusagehistorydashboard() {
      return new Promise((resolve) => {
        var data = {
          userid: this.userid,
          pageid: this.selectedBot.pageid,
          card_id: this.card_id
        }
        api.postgpkdiscountusagehistorydashboard(data, (err, response) => {
          if (response.responsecode == 200) {
            resolve(response.data)
          } else {
            resolve()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/grampablokof/MemberDetail.vue